export const MEMBER_TYPE_NAME = {
  1: '超级管理员',
  2: '管理员',
  3: '普通成员'
}
